import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { CheckboxList, ICheckboxList } from '../checkboxList/checkboxList.component.tsx';

export const FormCheckboxList: FC<IFormCheckboxList> = ({
  name,
  data,
  onChange,
  onBlur,
  ...props
}) => {
  return (
    <Controller
      name={name}
      defaultValue={data}
      render={({ field: { value, onChange: onFieldChange, onBlur: onFieldBlur } }) => {
        return (
          <CheckboxList
            data={value || []}
            onChange={(e) => {
              onFieldChange(e);
              onChange?.(e);
            }}
            onBlur={(e) => {
              onFieldBlur(); // notify react-hook-form when input is touched/blur
              onBlur?.(e);
            }}
            {...props}
          />
        );
      }}
    />
  );
};

interface IFormCheckboxList extends Omit<ICheckboxList, 'data'> {
  name: string;
  data?: ICheckboxList['data'];
}
